import { render, staticRenderFns } from "./ProductShelfTeaser.vue?vue&type=template&id=67d3ff2f&scoped=true&"
import script from "./ProductShelfTeaser.vue?vue&type=script&lang=js&"
export * from "./ProductShelfTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ProductShelfTeaser.vue?vue&type=style&index=0&id=67d3ff2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3ff2f",
  null
  
)

export default component.exports